export const URL_LOGIN = 'https://login.revuelta.com.mx/api/login/rawelt/mobile/authenticate';
export const URL_TOKEN = 'https://login.revuelta.com.mx/connect/token';
//PROTOTIPO
//export const DOMINIO = 'http://localhost:3000/INV/';
//export const DOMINIO = 'http://192.168.37.51:3000/INV/';
//export const DOMINIO = 'http://192.168.37.51:3001/INV/';
//export const DOMINIO = 'http://www.basculasrevueltalegacylocal.com/api/INV/';
//export const DOMINIO = 'https://basculasrevueltalegacypro.revuelta.com.mx/api/INV/';
//PRODUCCION
export const DOMINIO = 'https://basculasrevueltalegacy.revuelta.com.mx/api/INV/';
export const appId = 315;//